import { useEffect, useState } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { ProtectedMakerModeConfig } from '@drift-labs/sdk';

const DEFAULT_DATA = {
	maxUsers: 0,
	currentUsers: 0,
	reduceOnly: false,
};

const useProtectedMakerSlotsOpen = () => {
	const driftClient = useDriftStore((s) => s.driftClient.client);
	const [data, setData] = useState<ProtectedMakerModeConfig | undefined>(
		DEFAULT_DATA
	);

	useEffect(() => {
		const fetchProtectedMakerSlotsOpen = async () => {
			const protectedMakerConfig =
				await driftClient?.fetchProtectedMakerModeConfig();
			setData(protectedMakerConfig);
		};

		if (driftClient && driftClient.isSubscribed) {
			fetchProtectedMakerSlotsOpen();
		}
	}, [driftClient]);

	return {
		protectedMakerMaxSlots: data?.maxUsers ?? 0,
		protectedMakerSlotsOpen: (data?.maxUsers ?? 0) - (data?.currentUsers ?? 0),
		canJoin:
			(data?.maxUsers ?? 0) > (data?.currentUsers ?? 0) && !data?.reduceOnly,
	};
};

export default useProtectedMakerSlotsOpen;
